import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { broadcastPropsUpdated } from '../../../../components/preview-messages';
import { markWebsiteAsChanged } from '../../../../hooks/usePlusWebsites';

interface CreateWebsiteSectionParams {
  websiteId: string;
  sectionTypeId: string;
  version?: number;
  data: Record<string, unknown>;
}

function createWebsiteSection({ websiteId, ...body }: CreateWebsiteSectionParams) {
  return axiosPrivate
    .post(`/v3/pharmacist/plus-websites/${websiteId}/sections`, body)
    .then((r) => r.data);
}

export function useCreateWebsiteSection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createWebsiteSection,
    onSuccess: (_data, { websiteId }) => {
      markWebsiteAsChanged(queryClient, websiteId);
      broadcastPropsUpdated();
    },
    meta: {
      successMessage: 'Section created successfully',
      errorMessage: 'Failed to create section',
    },
  });
}
